import { ROLES } from '@/constants/roles';
import modules from './modules';

export default [
  {
    path: '/',
    redirect: { name: 'dashboard', params: { tab: 'general' } }
  },
  {
    path: '/dashboard/:tab?',
    name: 'dashboard',
    component: () => import('@/views/pages/dashboard/Dashboard.vue'),
    meta: {
      pageTitle: 'Dashboard',
      hidePageTitle: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true
        }
      ],
      verticalMenu: {
        title: 'Dashboard',
        icon: 'ActivityIcon'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER]
    }
  },
  // import route modules
  ...modules,
  // Setting Tab Menu
  {
    path: '',
    name: 'settingsGroup',
    meta: {
      // verticalMenu: {
      //   title: 'Settings',
      //   icon: 'SettingsIcon',
      //   isGroup: true
      // }
    }
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/pages/not-authorized',
    name: 'not-authorized',
    component: () => import('@/views/pages/authentication/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth'
    }
  },
  {
    path: '*',
    redirect: 'error-404'
  }
];
